export class HtmlEscapeUtils {
    private static htmlEscapeMapInstance: { [key: string]: string } | null = null;
    private static reversedHtmlEscapeMapInstance: { [key: string]: string } | null = null;

    static getHtmlEscapeMap(): { [key: string]: string } {
        if (HtmlEscapeUtils.htmlEscapeMapInstance === null) {
            HtmlEscapeUtils.htmlEscapeMapInstance = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;',
                '/': '&#x2F;',
                '`': '&#96;',
                'ä': '&auml;',
                'Ä': '&Auml;',
                'ö': '&ouml;',
                'Ö': '&Ouml;',
                'ü': '&uuml;',
                'Ü': '&Uuml;',
                'ß': '&szlig;',
                'à': '&agrave;',
                'è': '&egrave;',
                'ì': '&igrave;',
                'ò': '&ograve;',
                'ù': '&ugrave;',
                'á': '&aacute;',
                'é': '&eacute;',
                'í': '&iacute;',
                'ó': '&oacute;',
                'ú': '&uacute;',
                'â': '&acirc;',
                'ê': '&ecirc;',
                'î': '&icirc;',
                'ô': '&ocirc;',
                'û': '&ucirc;',
                // Add more entities as needed
            };
        }

        return HtmlEscapeUtils.htmlEscapeMapInstance;
    }

    static getReversedHtmlEscapeMap(): { [key: string]: string } {
        if (HtmlEscapeUtils.reversedHtmlEscapeMapInstance === null) {
            const htmlEscapeMap = HtmlEscapeUtils.getHtmlEscapeMap();
            HtmlEscapeUtils.reversedHtmlEscapeMapInstance = {};

            for (const [key, value] of Object.entries(htmlEscapeMap)) {
                HtmlEscapeUtils.reversedHtmlEscapeMapInstance[value] = key;
            }
        }

        return HtmlEscapeUtils.reversedHtmlEscapeMapInstance;
    }

    static escapeHtml(source: string): string {
        const entityMap = HtmlEscapeUtils.getHtmlEscapeMap();

        return source.replace(/([&<>"'\/`äöüÄÖÜßàèìòùáéíóúâêîôû])/g, match => {
            return entityMap[match];
        });
    }

    static unescapeHtml(source: string): string {
        const reversedEntityMap = HtmlEscapeUtils.getReversedHtmlEscapeMap();

        return source.replace(/&#?(?:x[a-fA-F0-9]+|[a-zA-Z0-9]+);/g, entity => {
            return reversedEntityMap[entity] ?? entity;
        });
    }

    static unescapeHtmlRepeatedly(source: string): string {
        let previous: string;
        let current = source;

        do {
            previous = current;
            current = HtmlEscapeUtils.unescapeHtml(previous);
        } while (previous !== current);

        return current;
    }

    static replaceLineBreaks(source: string, target: string): string {
        return source.replace(/(\r\n|\r|\n)/g, target);
    }
}